import React, { ReactElement } from 'react'

import { addAlert, addAlertSignature, removeAlert, removeAlertSignature } from '../actions/alerts'
import { deleteCompanyIntegration, getCompanyIntegrations } from '../actions/company-integrations'
import { createOutgoingLead, getOutgoingLeads } from '../actions/outgoing-leads'
import CodanComponent from '../components/basic-integrations/Codan'
import GrandhoodComponent from '../components/basic-integrations/Grandhood'
import MinRefusionComponent from '../components/basic-integrations/MinRefusion'
import RmindrComponent from '../components/basic-integrations/Rmindr'
import PersonalezonenIntr from '../components/personalezonen-integration/pzintegration'
import jsBrowserHistory from '../components/widgets/jsBrowserHistory'
import { OutgoingLeadType } from '../model/outgoingLead'
import { AlertReducer } from '../reducers/alerts'
import { CompanyReducer } from '../reducers/companies'
import { CompanyIntegrationReducer } from '../reducers/companyIntegrations'
import { CompanyPricingPackageReducer } from '../reducers/companyPricingPackages'
import { OutgoingLeadReducer } from '../reducers/outgoingLeads'
import { PricingPackageReducer } from '../reducers/pricingPackages'
import { connectToReducer } from '../utils/reducer-utils'
import { RouteProps } from '../utils/route-utils'
import IntegrationsLayout from './layouts/IntegrationsLayout'

type Reducers = {
  alerts: AlertReducer
  companies: CompanyReducer
  companyIntegrations: CompanyIntegrationReducer
  outgoingLeads: OutgoingLeadReducer
  pricingPackages: PricingPackageReducer
  companyPricingPackages: CompanyPricingPackageReducer
}

type Actions = {
  addAlert: addAlertSignature
  removeAlert: removeAlertSignature
  getCompanyIntegrations: () => void
  deleteCompanyIntegration: (companyIntegrationID: string) => void
  getOutgoingLeads: () => void
  createOutgoingLead: (leadType: OutgoingLeadType) => void
}

function BasicIntegration(props: Reducers & Actions & RouteProps): ReactElement | null {
  const company = props.companies.company
  if (!company) {
    jsBrowserHistory.push('/')
    return null
  }

  const section = props.location.pathname.split('/')[2] || 'codan'
  return (
    <IntegrationsLayout location={props.location} className={'basic-integrations'}>
      {section === 'codan' && (
        <CodanComponent
          alerts={props.alerts}
          company={company}
          companyIntegrations={props.companyIntegrations}
          outgoingLeads={props.outgoingLeads}
          addAlert={props.addAlert}
          removeAlert={props.removeAlert}
          getCompanyIntegrations={props.getCompanyIntegrations}
          deleteCompanyIntegration={props.deleteCompanyIntegration}
          getOutgoingLeads={props.getOutgoingLeads}
          createOutgoingLead={props.createOutgoingLead}
        />
      )}
      {section === 'pension' && <GrandhoodComponent company={company} />}
      {section === 'personalezonen' && (
        <PersonalezonenIntr
          company={company}
          isPremiumCustomer={props.companyPricingPackages.companyPricingPackages.some((pkg) => {
            const pricingPackage = props.pricingPackages.pricingPackages.find((p) => p.id === pkg.pricingPackageID)
            if (!pricingPackage) return false
            return pricingPackage.group === 'Premium' && pricingPackage.type === 'Base'
          })}
        />
      )}
      {section === 'rmindr' && <RmindrComponent />}
      {section === 'minrefusion' && <MinRefusionComponent />}
    </IntegrationsLayout>
  )
}

export default connectToReducer<Reducers, Actions, RouteProps>(
  (state) => ({
    alerts: state.alerts,
    companies: state.companies,
    companyIntegrations: state.companyIntegrations,
    outgoingLeads: state.outgoingLeads,
    pricingPackages: state.pricingPackages,
    companyPricingPackages: state.companyPricingPackages,
  }),
  {
    addAlert: addAlert,
    removeAlert: removeAlert,
    getCompanyIntegrations: getCompanyIntegrations,
    deleteCompanyIntegration: deleteCompanyIntegration,
    getOutgoingLeads: getOutgoingLeads,
    createOutgoingLead: createOutgoingLead,
  }
)(BasicIntegration)
